export const enum NetworkErrorCodeEnum {
    /**
     * 알 수 없는 에러
     */
    UNKNOWN_INTERNAL_ERROR = "UNKNOWN_INTERNAL_ERROR",
    UNKNOWN_ERROR = "UNKNOWN_ERROR",
    EMPTY_RESPONSE = "EMPTY_RESPONSE",
    UNKNOWN_RESPONSE = "UNKNOWN_RESPONSE",
}
